import { Logger } from '../../generic/utils';
import { wrapperIdentifier } from './common';
import { useEffect } from 'react';
import { wrapperBuilder } from './build';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}

wrapperBuilder.getCustomLogicRegisterInstance().setLogic(
  ({
    functions: { loadInstitutionAccounts },
    variablesHandler: {
      variables: { institutionAccounts },
      variablesSetter,
    },
    bindedContexts: { user },
  }) => {
    const userId = user && (user._id || user.id);

    useEffect(() => {
      if (userId) {
        console.log('Loading institutionAccounts');
        loadInstitutionAccounts();
      } else if (!userId) {
        if (institutionAccounts) {
          variablesSetter('institutionAccounts')(undefined);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);
  }
);
